import { render, staticRenderFns } from "./CMAttachmentsList.vue?vue&type=template&id=7a8fb312&scoped=true&"
import script from "./CMAttachmentsList.vue?vue&type=script&lang=js&"
export * from "./CMAttachmentsList.vue?vue&type=script&lang=js&"
import style0 from "./CMAttachmentsList.vue?vue&type=style&index=0&id=7a8fb312&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8fb312",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a8fb312')) {
      api.createRecord('7a8fb312', component.options)
    } else {
      api.reload('7a8fb312', component.options)
    }
    module.hot.accept("./CMAttachmentsList.vue?vue&type=template&id=7a8fb312&scoped=true&", function () {
      api.rerender('7a8fb312', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/attachments/CMAttachmentsPage/CMAttachmentsList.vue"
export default component.exports